import { useDispatch } from "react-redux"
import toastWrapper from "../../../components/toastWrapper"
import { dialogModes, dialogTypes, initialValues } from "../../../constants"
import { copyLessons, createLesson, deleteLesson, deleteLessons, resetCurrentLesson, setCurrentLesson, updateLesson } from "../../../redux/lessonsSlice"
import { updateLogBookItem } from "../../../redux/logBookItemsSlice"
import { createTask, updateTask } from "../../../redux/taskSlice"
import { addFileToLessonMaterial, createLessonMaterial, updateLessonMaterial } from "../../../redux/lessonMaterialSlice"


const useLessonActionHandlers = (openDialog, closeDialog, dialogData, savedFiles, resetFiles, userInfo, refetchLessons, checked, setChecked) => {

    const dispatch = useDispatch()

    const handleSetCurrentLesson = lesson => { dispatch(setCurrentLesson(lesson)) }

    const handleResetCurrentLesson = () => { dispatch(resetCurrentLesson()) }

    const handleIntent = (dialogData, dialogType, dialogMode) => {
        openDialog({ dialogData, dialogType, dialogMode })
    }

    const handleAction = (f, data, successMessage, errorMessage, onAfterSave) => {
        dispatch(f(data)).unwrap()
            .then(() => {
                toastWrapper(successMessage, "success")
                closeDialog()
                if (onAfterSave) { onAfterSave() }
            }).catch(e => {
                console.error(e)
                toastWrapper(errorMessage, "error")
            })
    }

    const handleCreateLesson = data => handleAction(createLesson, { ...data, employee: userInfo?.role?.id }, "Урок создан", "Не удалось создать урок")

    const handleCreateLessonIntent = () => handleIntent(initialValues.lesson, dialogTypes.LESSON, dialogModes.CREATE)

    const handleEditLesson = data => handleAction(updateLesson, data, "Урок отредактирован", "Не удалось отредактировать урок")

    const handleEditLessonIntent = data => handleIntent(data, dialogTypes.LESSON, dialogModes.UPDATE)

    const handleDeleteLesson = () => handleAction(
        dialogData ? deleteLesson : deleteLessons,
        dialogData ?? { lessons: checked?.map(x => x.id) ?? [] },
        dialogData ? "Урок удален" : "Уроки удалены",
        dialogData ? "Не удалось удалить урок" : "Не удалось удалить уроки",
        () => {
            setChecked([])
            refetchLessons()
        }
    )

    const handleDeleteLessonIntent = data => handleIntent(data, dialogTypes.LESSON, dialogModes.DELETE)

    const handleUpdateLogBook = async data => dispatch(updateLogBookItem(data)).unwrap()
        .catch(e => {
            console.error(e)
            toastWrapper("Не удалось сохранить изменения", "error")
        })

    const handleOpenTaskForm = data => { handleIntent(data, dialogTypes.TASK, dialogModes.UPDATE) }

    const handleEditTask = data => {
        handleAction(data?.id ? updateTask : createTask, data, "Изменения сохранены", "Не удалось сохранить изменения")
    }

    const handleOpenTaskAnswerDialog = data => { handleIntent(data, dialogTypes.TASK, dialogModes.VIEW) }

    const handleEditLessonMaterialIntent = lesson => {
        handleIntent(lesson, dialogTypes.LESSON_MATERIAL, dialogModes.CREATE)
    }

    const handleCreateLessonMaterial = data => {
        dispatch(createLessonMaterial(data)).unwrap().then(res => {
            dispatch(addFileToLessonMaterial({ files: savedFiles?.map(el => el.id) ?? [], id: res.id })).unwrap()
                .then(() => {
                    closeDialog()
                    toastWrapper("Изменения сохранены", "success")
                    resetFiles()
                })
                .catch(e => {
                    console.error(e)
                    toastWrapper("Не удалось прикрепить файлы", "error")
                })
        }).catch(e => {
            console.error(e)
            toastWrapper("Не удалось сохранить описание материала занятия", "error")
        })
    }

    const handleUpdateLessonMaterial = data => {
        Promise.all([
            dispatch(updateLessonMaterial(data)).unwrap(),
            dispatch(addFileToLessonMaterial({ files: savedFiles?.map(el => el.id) ?? [], id: data.id })).unwrap()
        ]).then(() => {
            closeDialog()
            toastWrapper("Изменения сохранены", "success")
            resetFiles()
        }).catch(e => {
            console.error(e)
            toastWrapper("Не удалось сохранить материал занятия")
        })
    }

    const handleCopyIntent = () => { handleIntent(null, dialogTypes.LESSON_COPY, dialogModes.CREATE) }
    const handleCopy = data => {
        handleAction(
            copyLessons,
            { ...data, employee: userInfo?.role?.id ?? null },
            `Занятия с ${new Date(data.start_date).toLocaleDateString()} по ${new Date(data.end_date).toLocaleDateString()} скопированы на ${data.weeks_count} недель вперед`,
            "Не удалось скопировать занятия",
            refetchLessons
        )
    }

    return {
        handleSetCurrentLesson, handleResetCurrentLesson,
        handleCreateLessonIntent, handleCreateLesson,
        handleEditLessonIntent, handleEditLesson,
        handleDeleteLessonIntent, handleDeleteLesson,
        handleUpdateLogBook,
        handleOpenTaskForm, handleEditTask, handleOpenTaskAnswerDialog,
        handleEditLessonMaterialIntent, handleCreateLessonMaterial, handleUpdateLessonMaterial,
        handleCopyIntent, handleCopy
    }
}

export default useLessonActionHandlers